import { render, staticRenderFns } from "./VideoModalMoveable.vue?vue&type=template&id=2d335784&scoped=true&"
import script from "./VideoModalMoveable.vue?vue&type=script&lang=js&"
export * from "./VideoModalMoveable.vue?vue&type=script&lang=js&"
import style0 from "./VideoModalMoveable.vue?vue&type=style&index=0&id=2d335784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d335784",
  null
  
)

export default component.exports